/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GETVIDEO, GETVIDEO_RECEIVED } = constants.GetVideoConstants;

export default {
  REQUEST_GETVIDEO,
  GETVIDEO_RECEIVED,

  requestAddVideoTag: () => ({
    type: REQUEST_GETVIDEO
  }),
  AddVideoTagReceived: () => ({
    type: GETVIDEO_RECEIVED
  })
};
